import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assests/images/menubar_logo.png";
import "../Styles/MenuBar.css";
import { clearAllData } from "../utils/store-data";
import { update_profile_active } from "../api/serverWrapper";

export default function MenuBarforClient({
  client,
  setActiveTab,
  displayActiveTab,
  setDisplayActiveTabs,
  handleProfileId,
  setDisplayAprrovedProfile,
}) {
  const navigate = useNavigate();

  const [showSettings, setShowSettings] = useState(false);
  const settingsRef = useRef(null);

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (settingsRef.current && !settingsRef.current.contains(e.target)) {
        setShowSettings(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const LogOut = async () => {
    await clearAllData();
    navigate("/home");
  };

  const handleToggleAccountStatus = async () => {
    try {
      const isCurrentlyActive = client?.IsActive;

      const confirmMsg = isCurrentlyActive
        ? "Are you sure you want to deactivate this account?"
        : "Are you sure you want to activate this account?";

      if (!window.confirm(confirmMsg)) return;

      let data = {
        ProfileId: client.ProfileId,
        IsActive: !isCurrentlyActive, // TOGGLE
      };

      console.log("Payload:", data);

      const resp = await update_profile_active(data);
      console.log("Response:", resp);

      if (resp?.code === 200 || resp?.success) {
        alert(
          isCurrentlyActive
            ? "Account deactivated successfully"
            : "Account activated successfully",
        );

        // logout only if deactivated
        if (isCurrentlyActive) {
          await clearAllData();
          navigate("/home");
        } else {
          window.location.reload(); // refresh to reflect active status
        }
      } else {
        alert("Operation failed");
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };

  return (
    <div>
      <header className="top-header d-flex justify-content-between align-items-center px-4 shadow-sm">
        <img
          src={logo}
          alt="WedLuk Logo"
          className="logos"
          style={{ height: "54px", cursor: "pointer" }}
        />

        <nav className="nav-menu d-flex gap-4 align-items-center">
          <span
            className={`nav-item ${
              displayActiveTab === "Matches" ? "active" : ""
            } click-effect`}
            onClick={() => {
              setDisplayActiveTabs("Matches");
              setActiveTab("matches");
              setDisplayAprrovedProfile(false);
            }}
          >
            Matches
          </span>

          {client?.AgentId && (
            <span
              className={`nav-item ${
                displayActiveTab === "My Agent" ? "active" : ""
              } click-effect`}
              onClick={() => {
                setDisplayActiveTabs("My Agent");
                setActiveTab("matches");
              }}
            >
              My Agent
            </span>
          )}

          <span
            className={`nav-item ${
              displayActiveTab === "Profile" ? "active" : ""
            } click-effect`}
            onClick={() => {
              setDisplayActiveTabs("Profile");
              setActiveTab("matches");
              handleProfileId(client?.ProfileId);
            }}
          >
            Profile
          </span>

          {/* SETTINGS */}
          <div
            className="nav-item position-relative click-effect"
            ref={settingsRef}
            onClick={() => setShowSettings(!showSettings)}
          >
            Settings
            {showSettings && (
              <div className="settings-popup shadow-sm">
                <div className="settings-item" onClick={LogOut}>
                  Logout
                </div>
                {/* 
                <div
                  className="settings-item"
                  onClick={() => navigate("/home")}
                >
                  Switch account
                </div> */}

                <div
                  className="settings-item text-danger"
                  onClick={() => handleToggleAccountStatus()}
                >
                  {client?.IsActive ? "Deactivate Account" : "Activate Account"}
                </div>
              </div>
            )}
          </div>
        </nav>
      </header>
    </div>
  );
}
